// Mirrors Tp_Communication.Enum.InvoiceAutomationRunTriggerTypeTextEnum — keep in sync.
const InvoiceAutomationRunTriggerTypeEnum = {
  Daily: 'Daily',
  OnDemand: 'OnDemand',
};

export default InvoiceAutomationRunTriggerTypeEnum;
